export const extractInvoiceIdFromInput = (rawValue) => {
  if (!rawValue && rawValue !== 0) return null;
  const trimmed = String(rawValue).trim();
  if (!trimmed) return null;

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const url = new URL(trimmed);
      const param =
        url.searchParams.get("invoiceid") ||
        url.searchParams.get("invoiceId") ||
        url.searchParams.get("invoice") ||
        url.searchParams.get("id");
      if (param && param.trim()) return param.trim();

      const segments = url.pathname.split("/").filter(Boolean);
      for (let i = segments.length - 1; i >= 0; i -= 1) {
        const segment = segments[i].trim();
        if (!segment) continue;
        if (/^[A-Za-z0-9_-]+$/.test(segment)) {
          return segment;
        }
      }
    } catch (_) {
      // fall through to fallback parsing
    }
  }

  const match = trimmed.match(/[A-Za-z0-9_-]+$/);
  if (match && match[0]) return match[0];

  return trimmed;
};
